import { all } from 'redux-saga/effects';
import rootProjectSaga from '../sagas';

function* rootSaga() {
  yield all([
    rootProjectSaga(),
  ]);
}

export default rootSaga;
